import React from "react";
import PropTypes from "prop-types";
import {ASelect} from "@cisco-sbg-ui/magna-react";
import classNames from "classnames";
import {FieldNames} from "models/fields";
import {LAYOUT_OPTIONS, LAYOUTS} from "utils/graph/graphStyleConstants";
import css from "./LayoutSelectDropdown.module.scss";

const LayoutSelectDropdown = ({setLayout, disabled}) => (
  <ASelect
    className={classNames(css.dropdown, "mr-2")}
    medium
    items={LAYOUT_OPTIONS}
    itemText={FieldNames.name}
    itemValue={FieldNames.value}
    onSelected={(event) => setLayout(LAYOUTS[event.value])}
    disabled={disabled}
  />
);

LayoutSelectDropdown.propTypes = {
  setLayout: PropTypes.func,
  disabled: PropTypes.bool
};

export default LayoutSelectDropdown;
